const label = (intl, key, params) => {
  return intl.formatMessage({ id: key }, params);
};

export default label;
